import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Avatar,
  Box,
  Chip,
  Grid,
} from "@mui/material";
import AccountProfileDetails from "./Form_micuenta";

const PerfilDetalle = ({ userData, companyData }) => {
  if (!userData || !companyData) return null;

  return (
    <Card>
      <CardContent>
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Avatar
            src={userData.avatar}
            sx={{ width: 80, height: 80, margin: "auto" }}
          />
          <Typography variant="h6" sx={{ mt: 1 }}>
            {userData.displayName}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {userData.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Rol
            </Typography>
            <Typography>{userData.userCompanyRoll}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Teléfono
            </Typography>
            <Typography>{userData.userPhone || "Sin registro"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Empresa Principal
            </Typography>
            <Typography>{userData.userCompany}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" color="textSecondary">
              RUT Empresa
            </Typography>
            <Typography>{companyData.companyRut}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="textSecondary">
              Dirección
            </Typography>
            <Typography>
              {companyData.companyAddress || "Sin dirección registrada"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="textSecondary">
              Colabora con
            </Typography>
            <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}>
              {userData.companyCollaborator?.map((item, idx) => (
                <Chip key={idx} label={item} size="small" color="primary" />
              ))}
            </Box>
          </Grid>
        </Grid>
        <AccountProfileDetails userData={userData}></AccountProfileDetails>
      </CardContent>
    </Card>
  );
};

export default PerfilDetalle;
